export enum EProductOfferingType {
    Service = 3
}
